import { type InjectionKey, type Ref, ref } from 'vue';

const STORAGE_KEY = 'jobEdit:sectionsOrder';

export const IsDraggingKey: InjectionKey<Ref<boolean>> =
  Symbol('jobEditIsDragging');

export const DRAG_HANDLE_CLASS = 'jobedit-drag-handle';
export const SECTION_IDS = [
  'customer',
  'stops',
  'productsServices',
  'status',
  'other',
  'photos',
] as const;

export type SectionId = (typeof SECTION_IDS)[number];

function isSectionId(value: unknown): value is SectionId {
  return SECTION_IDS.includes(value as SectionId);
}

// Migrate saved order across SECTION_IDS additions/removals so users don't
// lose their layout when the section list changes: keep recognised ids in
// saved order, drop unknown ones, append any missing.
function loadOrder(): SectionId[] {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed: unknown = JSON.parse(saved);
      if (Array.isArray(parsed)) {
        const known = parsed.filter(isSectionId);
        const missing = SECTION_IDS.filter((id) => !known.includes(id));
        return [...known, ...missing];
      }
    }
  } catch {
    // ignore corrupt data
  }
  return [...SECTION_IDS];
}

export function useJobEditSectionsOrder() {
  const order = ref<SectionId[]>(loadOrder());

  function setOrder(newOrder: SectionId[]): void {
    order.value = newOrder;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newOrder));
  }

  return { order, setOrder };
}
